import { useState, useRef, useEffect } from "react";
import { callAIApi } from "../services/apiService";
import { v4 as uuidv4 } from 'uuid';
import SpeechRecognition, {
  useSpeechRecognition,
  ListeningOptions
} from 'react-speech-recognition';

function CallAI() {
  const [messages, setMessages] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [current_user_chat_code, setCurrent_user_chat_code] = useState("");
  const [lastTranscript, setLastTranscript] = useState("");
  const [aiShortAnswer, setAiShortAnswer] = useState("");
const [aiFullData, setAiFullData] = useState("");
const [showFullData, setShowFullData] = useState(false);

  const inactivityTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  useEffect(() => {
    setCurrent_user_chat_code(uuidv4());
  }, []);

  useEffect(() => {
    if (!transcript || transcript === lastTranscript) return;

    if (inactivityTimeoutRef.current) {
      clearTimeout(inactivityTimeoutRef.current);
    }

    inactivityTimeoutRef.current = setTimeout(() => {
      const clean = transcript.trim();
      if (clean) {
        setMessages((prev) => [...prev, clean]);
        setLastTranscript(clean);
        resetTranscript();
      }
    }, 1000);
  }, [transcript]);

  const handleBotReply = async () => {
    const fullConversation = messages.join(" ");
    if (!fullConversation.trim()) return;

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("userQuery", fullConversation);
      formData.append("current_user_chat_code", current_user_chat_code);

      const response = await callAIApi(formData);
      const cleanedReply = JSON.parse(response.reply.replace(/^```json\s*/, '') .replace(/```$/, '')) || "No response"
      console.log(response.reply)
      setAiShortAnswer(cleanedReply.short_answer.replace(/【.*?】/g, '') || "N/A");
      setAiFullData(cleanedReply.full_data.replace(/【.*?】/g, '') || "N/A");

      setShowFullData(false);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (!browserSupportsSpeechRecognition) {
    return <div>Browser doesn't support speech recognition</div>;
  }

  return (
    <div className="w-full h-screen flex flex-col bg-white">
      <div className="bg-blue-600 text-white text-center py-4 text-xl font-semibold shadow-md">
        CALL Assistant
      </div>

      <div className="flex w-full h-full">
        <div className="bg-gray-100 w-[80%] flex items-center justify-center">
          <button
            onClick={() => {
              const options: ListeningOptions = {
                continuous: true,
                language: 'en-US',
              };
              SpeechRecognition.startListening(options);
            }}
            disabled={loading}
            className="px-5 py-3 font-bold rounded text-white bg-red-500 hover:bg-red-600 transition-colors"
          >
            Start Call
          </button>
        </div>

        <div className="w-[20%] bg-gray-200 flex flex-col items-center justify-start pt-6 space-y-4">
          <button
            onClick={handleBotReply}
            disabled={loading}
            className={`px-6 py-2 font-bold rounded text-white transition-colors duration-200 ${
              loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            Help Me!
          </button>

          <div className="w-[90%] bg-green-50 border border-green-400 p-4 rounded shadow text-sm text-gray-800">
            <p className="text-green-700 font-semibold mb-2">AI Summary:</p>
            <p className="mb-2">{aiShortAnswer || "No answer yet."}</p>

            {aiFullData && !showFullData && (
                <button
                onClick={() => setShowFullData(true)}
                className="text-blue-600 underline text-xs"
                >
                Show All Data
                </button>
            )}

            {showFullData && (
                <div className="mt-2 text-gray-700 whitespace-pre-wrap">
                {aiFullData}
                </div>
            )}
        </div>

          <div className="w-[90%] bg-white p-2 rounded shadow text-xs text-gray-800 h-[60%] overflow-y-auto">
            <p className="font-semibold mb-1">Live Transcript:</p>
            {messages.map((msg, index) => (
              <p key={index} className="mb-1">• {msg}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CallAI;
